var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYellowBoltR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 20,
  height: 20,
  viewBox: "0 0 64 64",
  className: "r-14g73ha r-u4f6dq r-u8s1d r-ipm5af r-1b94p3d",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFB636",
  stroke: "#FFB636",
  strokeLinejoin: "bevel",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M40 1 17 37h14l-7 26 26-36H36z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgYellowBoltR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/yellow-bolt-r.bd65ae57f28232904aa4e516237d845f.svg";